import { useState } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn, FieldValues, Path } from "react-hook-form";
import MultipleSelector from "@/components/ui/multiple-select";
import { cn } from "@/lib/utils";

interface FormMultipleSelectorProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  label: string;
  id: Path<T>;
  maxSelected?: number;
  defaultOptions: { label: string; value: string }[];
  creatable?: boolean;
  placeholder?: string;
  hidePlaceholderWhenSelected?: boolean;
  slugifyValue?: boolean;
  disabled?: boolean;
  description?: string;
}

export default function FormMultipleSelector<T extends FieldValues>({
  form,
  label,
  id,
  maxSelected,
  defaultOptions,
  creatable = false,
  placeholder,
  hidePlaceholderWhenSelected = true,
  slugifyValue,
  disabled,
  description,
}: FormMultipleSelectorProps<T>) {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  return (
    <FormField
      control={form.control}
      name={id}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <div>
                <MultipleSelector
                  {...field}
                  hideClearAllButton
                  slugifyValue={slugifyValue}
                  creatable={creatable}
                  placeholder={placeholder}
                  hidePlaceholderWhenSelected={hidePlaceholderWhenSelected}
                  maxSelected={maxSelected}
                  disabled={disabled}
                  badgeClassName={cn(disabled && "")}
                  onMaxSelected={(maxLimit) => {
                    setErrorMessage(`Max amount reached (${maxLimit})`);
                  }}
                  defaultOptions={defaultOptions}
                  emptyIndicator={
                    <p className="text-center text-sm leading-10 text-primary-foreground">
                      No results found.
                    </p>
                  }
                />
                {description && (
                  <p className="text-xs text-muted-foreground">{description}</p>
                )}
                <FormMessage>{errorMessage}</FormMessage>
              </div>
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
}




// import {
//   FormField,
//   FormItem,
//   FormLabel,
//   FormControl,
//   FormMessage,
// } from "../ui/form";
// import MultipleSelector from "../ui/multiple-selector";
//
// export default function FormSelectMultiple({
//   id,
//   label,
//   options,
//   noResMessage,
//   placeholder,
//   maxSelected,
//   creatable,
//   customBadgeClasses,
//   singleItem,
//   onChange,
//   commandProps,
//   form,
// }: {
//   id: string;
//   label: string;
//   options: any[];
//   noResMessage?: string;
//   placeholder?: string;
//   maxSelected?: number;
//   creatable?: boolean;
//   customBadgeClasses?: string;
//   singleItem?: boolean;
//   onChange?: (fff: any) => void;
//   commandProps?: any;
//   form: any;
// }) {
//   return (
//     <FormField
//       control={form.control}
//       name={id}
//       render={({ field }) => {
//         return (
//           <FormItem>
//             <FormLabel className="mb-1">{label}</FormLabel>
//             <FormMessage className="text-xs mt-0 pt-0" />
//             <FormControl className="">
//               <MultipleSelector
//                 hidePlaceholderWhenSelected
//                 value={field.value}
//                 onChange={onChange || field.onChange}
//                 options={options}
//                 creatable={creatable}
//                 maxSelected={maxSelected}
//                 placeholder={placeholder || "Select an option"}
//                 emptyIndicator={
//                   <p className="text-center text-xs">
//                     {noResMessage || "No results found."}
//                   </p>
//                 }
//                 // badgeClassName={`rounded-sm text-xs text-ellipsis w-full! min-w-fit m-0 p-0 ${customBadgeClasses}`}
//                 className=""
//                 singleItem={singleItem}
//                 commandProps={commandProps}
//                 inputProps={{ className: "" }}
//               />
//             </FormControl>
//           </FormItem>
//         );
//       }}
//     />
//   );
// }
